export const InputLabel = (props: {
    children: React.ReactNode,
    required?: boolean,
}) => {
  return <span className="text-sm header-font text-gray-700 cursor-pointer">
    {props.children}{props.required && props.required ? <span className="pl-1 text-red-500">*</span> : null}
  </span>
}